import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { environment } from 'src/environments/environment';
import { initialMarginNotesSlice } from './margin-notes.slice';
import { MarginNotes } from '../../models/margin-notes.models';

export const MarginNotesStore = signalStore(
    { providedIn: 'root' },
    withState(initialMarginNotesSlice),
    withMethods((store) => ({
        updateMarginNotes: (data: Partial<MarginNotes>) => {
            patchState(store, { ...data });
        },
        getState: () => store
    })),
    environment.storeWithDevTools('locums-margin-calculator-margin-notes-store')
);
